const COLOR_PROFILES = {
  CMYK: 'CMYK'
};

export { COLOR_PROFILES };
